import { css } from 'styled-components';

/**
 * Kieu dung chung cho ba o tren thanh filter calendar: chon ngay, tim khach, Book By Staff.
 *
 * Truoc day moi component tu khai bao rieng nen ba o lech nhau — o chon ngay cao 46px con hai
 * o kia 40px, chu thi moi o mot co va mot do dam. Lay o "Book By Staff" lam chuan.
 */
export const FILTER_INPUT_HEIGHT = '40px';
export const FILTER_INPUT_FONT_SIZE = '18px';

export const filterInputText = css`
  color: #1D2129;
  font-family: Poppins;
  font-size: ${FILTER_INPUT_FONT_SIZE};
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

/**
 * Ba o chia deu chieu ngang con lai cua thanh filter.
 *
 * `flex: 1` dat flex-basis ve 0 nen ba o rong bang nhau bat ke noi dung ben trong dai ngan
 * khac nhau. `min-width: 0` la bat buoc: mac dinh `min-width: auto` khong cho flex item co
 * nho hon noi dung, o tim khach (placeholder dai + o suffix) se phinh to hon hai o kia.
 */
export const filterInputBox = css`
  flex: 1;
  min-width: 0;
`;
